import React from "react";

const BS5_Colors = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Colors Component</h2>
      <p>This is the BS5_Colors component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Colors;
